export const FormationPositions: { [key: string]: { x: number, y: number } } = {
  TW: { x: 0, y: 0 },
  LV: { x: 2, y: 0 },
  LAV: { x: 3, y: 0 },
  LIV: { x: 1, y: -0.5 },
  ZIV: { x: 0, y: 0 },
  RIV: { x: -1, y: -0.5 },
  RAV: { x: -3, y: 0 },
  RV: { x: -2, y: 0 },
  LM: { x: 3, y: 0 },
  LIM: { x: 1, y: -0.5 },
  RIM: { x: -1, y: -0.5 },
  ZLM: { x: 1, y: -0.5 },
  ZLDM: { x: 1.5, y: -1.5 },
  ZDM: { x: 0, y: -1.5 },
  ZM: { x: 0, y: 0 },
  ZRDM: { x: -1.5, y: -1.5 },
  ZRM: { x: -1, y: -0.5 },
  RM: { x: -3, y: 0 },
  ZOM: { x: 0, y: 1.5 },
  ZOLM: { x: 1.5, y: 1.5 },
  ZORM: { x: -1.5, y: 1.5 },
  LS: { x: 2, y: 0 },
  MS: { x: 0, y: 0 },
  RS: { x: -2, y: 0 }
};

export interface IFormation {
  id: number;
  name: string;
  positions: string[];
}

// Formations https://gitlab.com/skamanderapp/backend/wikis/formation-ids
export const Formations: IFormation[] = [
  {
    id: -1,
    name: 'Keine Formation',
    positions: ['N1', 'N2', 'N3', 'N4', 'N5', 'N6', 'N7', 'N8', 'N9', 'N10', 'N11']
  },
  {
    id: 0,
    name: '3-4-3',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'LM', 'ZLM', 'ZRM', 'RM', 'LS', 'MS', 'RS']
  },
  {
    id: 1,
    name: '3-2-2-1-2',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'ZLDM-back', 'ZRDM-back', 'LM', 'RM', 'ZOM', 'LS-2', 'RS-2']
  },
  {
    id: 2,
    name: '4-1-1-3-1',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM', 'ZM', 'LM-front', 'ZOM', 'RM-front', 'MS']
  },
  {
    id: 3,
    name: '4-1-2-3',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM-front-2', 'LM-front-2', 'RM-front-2', 'LS', 'MS', 'RS']
  },
  {
    id: 4,
    name: '4-1-4-1',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM-front-2', 'LM-front-2', 'ZLM-front-2', 'ZRM-front-2', 'RM-front-2', 'MS']
  },
  {
    id: 5,
    name: '4-2-3-1',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZLDM-side', 'ZRDM-side', 'LM-front-2', 'ZOM-2', 'RM-front-2', 'MS']
  },
  {
    id: 6,
    name: '4-3-1-2',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM-back-3', 'ZDM-front-2', 'RM-back-3', 'ZOM-2', 'LS-2', 'RS-2']
  },
  {
    id: 7,
    name: '4-3-2-1',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM-back', 'ZM-back', 'RM-back', 'ZOLM-2', 'ZORM-2', 'MS']
  },
  {
    id: 8,
    name: '4-3-3',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM-3', 'ZM', 'RM-3', 'LS', 'MS', 'RS']
  },
  {
    id: 9,
    name: '4-4-2',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM', 'ZLM', 'ZRM', 'RM', 'LS-2', 'RS-2']
  },
  {
    id: 10,
    name: '4-1-2-1-2',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM', 'LM', 'RM', 'ZOM', 'LS-2', 'RS-2']
  },
  {
    id: 11,
    name: '5-3-2',
    positions: ['TW', 'LAV-5', 'LIV-5', 'ZIV', 'RIV-5', 'RAV-5', 'LM-3', 'ZM', 'RM-3', 'LS-2', 'RS-2']
  },
  {
    id: 12,
    name: '5-4-1',
    positions: ['TW', 'LAV-5', 'LIV-5', 'ZIV', 'RIV-5', 'RAV-5', 'LM', 'ZLM', 'ZRM', 'RM', 'MS']
  },
  {
    id: 13,
    name: '4-1-3-2',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZDM-front-2', 'LM-front-2', 'ZOM-2', 'RM-front-2', 'LS-2', 'RS-2']
  },
  {
    id: 14,
    name: '5-2-1-2',
    positions: ['TW', 'LAV-5', 'LIV-5', 'ZIV', 'RIV-5', 'RAV-5', 'ZLDM', 'ZRDM', 'ZOM-2', 'LS-2', 'RS-2']
  },
  {
    id: 15,
    name: '4-5-1',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM-5', 'ZLM-5', 'ZM', 'ZRM-5', 'RM-5', 'MS']
  },
  {
    id: 16,
    name: '3-5-1-1',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'LM-back-5', 'ZLM-5-back',  'ZDM-front-5', 'ZRM-5-back', 'RM-back-5',  'ZOM-2', 'MS']
  },
  {
    id: 17,
    name: '3-4-2-1',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'LM-back-3', 'ZLDM', 'ZRDM', 'RM-back-3', 'ZOLM-back', 'ZORM-back', 'MS']
  },
  {
    id: 18,
    name: '4-2-2-2',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'ZLDM-side', 'ZRDM-side', 'LM-front-2',  'RM-front-2', 'LS-2', 'RS-2']
  },
  {
    id: 19,
    name: '3-5-2',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'LM-5', 'ZLM-5', 'ZM', 'ZRM-5', 'RM-5', 'LS-2', 'RS-2']
  },
  {
    id: 20,
    name: '3-1-4-2',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'ZDM-front-2', 'LM-front-2', 'ZLM-front-2', 'ZRM-front-2', 'RM-front-2', 'LS-2', 'RS-2']
  },
  {
    id: 21,
    name: '4-4-1-1',
    positions: ['TW', 'LAV', 'LIV', 'RIV', 'RAV', 'LM-back-3', 'ZLDM', 'ZRDM', 'RM-back-3', 'ZOM-2', 'MS']
  },
  {
    id: 22,
    name: '5-5-0',
    positions: ['TW', 'LAV-5', 'LIV-5', 'ZIV', 'RIV-5', 'RAV-5', 'LM-5', 'ZLM-5', 'ZM', 'ZRM-5', 'RM-5']
  },
  {
    id: 23,
    name: '5-3-1-1',
    positions: ['TW', 'LAV-5', 'LIV-5', 'ZIV', 'RIV-5', 'RAV-5', 'LM-3-back', 'ZDM-front-2', 'RM-3-back', 'ZOM-2', 'MS']
  },
  {
    id: 24,
    name: '3-4-1-2',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'LM-back-3', 'ZLDM', 'ZRDM', 'RM-back-3', 'ZOM-2', 'LS-2', 'RS-2']
  },
  {
    id: 25,
    name: '5-2-3',
    positions: ['TW', 'LAV-5', 'LIV-5', 'ZIV', 'RIV-5', 'RAV-5', 'ZLM', 'ZRM', 'LS', 'MS', 'RS']
  },
  {
    id: 26,
    name: '3-3-1-3',
    positions: ['TW', 'LV', 'ZIV', 'RV', 'LM-back-3', 'ZDM-front-2', 'RM-back-3', 'ZOM-2', 'LS', 'MS', 'RS']
  }
];
